export enum TestExecutionStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCEEDED = "SUCCEEDED",
  FAILED = "FAILED",
  ABORTED = "ABORTED",
}

export interface IndividualTestExecution {
  status: TestExecutionStatus;
  celery_task_id: string | null;
  validation_results: Record<string, boolean>;
  start_time: string | null;
  end_time: string | null;
  total_execution_time: number | null;
  exception_message: string | null;
}

export interface AutomatedTestSuiteExecution {
  tests: Record<string, IndividualTestExecution>;
  created_at: string | null;
}

export interface PollAutomatedTestSuiteExecutionResponse {
  execution: AutomatedTestSuiteExecution | null;
}
